function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "twitter",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.952468,7.54571395 C19.9646557,7.7220292 19.9646557,7.89834446 19.9646557,8.07628474 C19.9646557,13.498182 15.8370912,19.7512797 8.28966078,19.7512797 C6.06012594,19.7512797 3.87690433,19.1126447 2,17.9085009 C2.32419257,17.9475015 2.65001016,17.9670018 2.97664026,17.9678143 C4.82429413,17.9694393 6.61913467,17.3494921 8.07271989,16.2079118 C6.31687995,16.1745988 4.77716839,15.0297684 4.23928499,13.3584298 C4.8543571,13.4770566 5.488117,13.4526812 6.09181393,13.2877412 C4.17753402,12.9009851 2.80032501,11.2190838 2.80032501,9.26580332 C2.80032501,9.24792804 2.80032501,9.23086528 2.80032501,9.21380251 C3.37070892,9.53149497 4.0093439,9.70781023 4.6626041,9.72731053 C2.85963843,8.52235421 2.30387975,6.12381673 3.39264676,4.24853743 C5.47592931,6.81201498 8.54966484,8.37041433 11.8492789,8.53535441 C11.5185862,7.11020714 11.9703433,5.61680881 13.0363599,4.61498065 C14.6890108,3.06145638 17.2882389,3.14108262 18.8417632,4.79292093 C19.760715,4.6117306 20.6414788,4.27453783 21.4474914,3.79678037 C21.1411741,4.74660771 20.5001016,5.55343282 19.6437132,6.06612833 C20.4570384,5.97025183 21.2516758,5.75249843 22,5.42018073 C21.4491164,6.24569363 20.7552306,6.96476737 19.952468,7.54571395 Z",
  id: "Color",
  fill: "#1D9BF0"
}));

function SvgIcTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitter);
export default __webpack_public_path__ + "static/media/ic_twitter.f14f92bf6cd74f41b492766257c3e77b.svg";
export { ForwardRef as ReactComponent };